var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "content" },
    [
      _c("Username", { attrs: { user: _vm.message.from } }),
      _vm._v("  u largua nga kanali\n\t"),
      _vm.message.text ? _c("i", { staticClass: "part-reason" }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }